import algoliasearch from 'algoliasearch/lite'

export const searchClient = algoliasearch(
  process.env.VUE_APP_ALGOLIA_API_ID,
  process.env.VUE_APP_ALGOLIA_API_KEY
)
